var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1752 2.5212C8.34056 2.23406 8.70744 2.13534 8.99456 2.30073C10.1394 2.96006 11.0345 3.97879 11.5412 5.19884C12.0478 6.41889 12.1377 7.77208 11.7968 9.0484C11.4558 10.3247 10.7032 11.4529 9.65568 12.2578C8.60816 13.0626 7.32424 13.4994 6.00312 13.5C4.68207 13.5007 3.39769 13.0654 2.3493 12.2616C1.3009 11.4578 0.547103 10.3304 0.204855 9.05448C-0.1374 7.77848 -0.0489684 6.42522 0.456423 5.20464C0.961815 3.98406 1.85592 2.9644 3 2.30386C3.28697 2.13818 3.65393 2.2365 3.81961 2.52348C3.9853 2.81046 3.88697 3.17741 3.6 3.3431C2.68473 3.87153 1.96945 4.68725 1.56514 5.66372C1.16082 6.64018 1.09008 7.7228 1.36388 8.7436C1.63769 9.76432 2.24073 10.6662 3.07944 11.3093C3.91816 11.9523 4.94565 12.3006 6.00248 12.3C7.05936 12.2994 8.08648 11.9502 8.92456 11.3062C9.76256 10.6622 10.3647 9.75976 10.6374 8.73872C10.9102 7.71768 10.8382 6.63512 10.433 5.65908C10.0276 4.68304 9.31144 3.86806 8.39568 3.34058C8.10848 3.1752 8.00976 2.80835 8.1752 2.5212ZM6 0.5C6.30374 0.5 6.55479 0.725725 6.59452 1.01858L6.6 1.1V5.9C6.6 6.23137 6.33136 6.5 6 6.5C5.69624 6.5 5.44521 6.27427 5.40547 5.98141L5.4 5.9V1.1C5.4 0.768632 5.66863 0.5 6 0.5Z",
    fill: "#3152E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/power-icon.2d5a7bf08679bc25dae1e51b9bce81d4.svg";
export { ForwardRef as ReactComponent };